import React from 'react'
import defaultClasses from './ookaTogether.module.scss'
import { string } from 'prop-types'
import Slider from 'react-slick'
import { useIsArabic } from '@components/common/IsArabic/useIsArabic'

const ookaTogetherSettings = {
    centerMode: true,
    slidesToShow: 3,
    speed: 4000,
    autoplaySpeed: 0,
    infinite: true,
    autoplay: true,
    accessibility: false,
    cssEase: 'linear',
    rtl: false,
    arrows: false,
    dots: false,
    pauseOnHover: true,
    pauseOnFocus: true,
    draggable: true,
    swipe: true,
    touchThreshold: 10,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                centerPadding: '15%'
            }
        },
        {
            breakpoint: 767,
            settings: {
                pauseOnDotsHover: true,
                pauseOnFocus: true,
                slidesToShow: 1,
                centerPadding: '20%'
            }
        }
    ]
}

const OokaTogether = (props) => {
    const {
        backgroundColor,
        topHeading,
        topHeadingColor,
        heading,
        headingColor,
        children,
        textElement
    } = props

    const isArabic = useIsArabic()

    const headingStyles = {
        color: headingColor
    }

    const topHeadingStyles = {
        color: topHeadingColor
    }

    const wrapperStyles = {
        backgroundColor: backgroundColor
    }

    return (
        <div className={defaultClasses['ooka-together']} style={wrapperStyles}>
            <div className={defaultClasses['ooka-together-wrapper']}>
                <span
                    className={defaultClasses['ooka-together-label']}
                    style={topHeadingStyles}
                >
                    {topHeading}
                </span>
                <div className={defaultClasses['ooka-together-top']}>
                    <div className={defaultClasses['ooka-together-top-left']}>
                        <h2
                            className={defaultClasses['ooka-together-heading']}
                            style={headingStyles}
                        >
                            {heading}
                        </h2>
                    </div>
                    <div className={defaultClasses['ooka-together-top-right']}>
                        <div
                            style={headingStyles}
                            dangerouslySetInnerHTML={{ __html: textElement }}
                        />
                    </div>
                </div>
            </div>
            <div className={defaultClasses['ooka-together-slider-wrapper']}>
                <Slider {...ookaTogetherSettings} rtl={!isArabic}>
                    {children}
                </Slider>
            </div>
        </div>
    )
}

OokaTogether.propTypes = {
    backgroundColor: string,
    topHeading: string,
    topHeadingColor: string,
    heading: string,
    headingColor: string,
    textElement: string
}

export default OokaTogether
